<template>
  <FlexCol gap-1 class="relative">
    <Label :label="label" :required="required" :error="error" v-if="label" />
    <Input v-model="localValue" :error="error" placeholder="dd/mm/yyyy" :disabled="disabled">
      <template #pre-icon>
        <IconInput icon="fa-calendar-days" @click="toggle" class="border-r" />
      </template>
      <template #pos-icon>
        <IconInput icon="fa-xmark" class="border-l" @click="clear()" v-if="localValue" />
      </template>
    </Input>
    <Error :message="error" v-if="error" />
    <Calendar v-if="open" range class="absolute top-full z-10 w-full mt-2" v-model="date" />
  </FlexCol>
</template>

<script setup>
import { watch, ref } from 'vue'
import { useUtils } from '@/composables/useUtils'
import { useFormat } from '@/composables/useFormat'
const { formatBrDateToIso, formatIsoDatetime, formatRangeDate } = useFormat()
const { isValidDateBR } = useUtils()

const props = defineProps({
  label: String,
  required: Boolean,
  disabled: Boolean,
  error: Array,
  modelValue: [Array, String],
  placeholder: String,
})

const emits = defineEmits(['update:modelValue'])
const localValue = ref(props.modelValue ? formatRangeDate(props.modelValue) : [])

const error = ref(props.error)
const open = ref(false)
const date = ref(null)

const toggle = () => {
  open.value = !open.value
}

const clear = () => {
  localValue.value = []
  date.value = []
  emits('update:modelValue', [])
}

watch(
  date,
  (newValue) => {
    if (Array.isArray(newValue)) {
      const [start, end] = newValue
      const result = []

      if (start) {
        const startDate = new Date(start)
        startDate.setHours(0, 0, 0, 0)
        result[0] = formatIsoDatetime(startDate)
      }

      if (end) {
        const endDate = new Date(end)
        endDate.setHours(23, 59, 59, 999)
        result[1] = formatIsoDatetime(endDate)
      }

      emits('update:modelValue', result)

      if (result.length === 2) {
        toggle()
      }
    }
  },
  { deep: true }
)

watch(
  () => props.modelValue,
  (newValue) => {
    localValue.value = formatRangeDate(newValue)
  },
  { deep: true }
)

watch(
  () => props.error,
  (newValue) => {
    error.value = newValue
  }
)
</script>
